import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './reducers/rootStore';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

// Get the application-wide store instance, prepopulating with state from the server where available.

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<Provider store={store}>
    <BrowserRouter>
        <App />
    </BrowserRouter>
</Provider>);

